import ApiService from "./api.service";

const DishonestRequestService = {
  GetList(data) {
    return ApiService.post(`/DishonestRequest/GetList`, data);
  },
  GetSecurityInfo() {
    return ApiService.get(`/DishonestRequest/GetSecurityInfo`);
  },
};
export default DishonestRequestService;
